import { storage, db, auth } from "../firebaseConfig";
import { ref as dbRef, set, get, ref, remove, update } from "firebase/database";
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut } from "firebase/auth";
import {
  ref as storageRef,
  uploadBytesResumable,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";

export const cadastrarCorretor = async (creci, nome, sobrenome, telefone, email, senha, imagem) => {
  try {
    const usuarioAtual = auth.currentUser;
    const emailAdmin = usuarioAtual.email;
    const senhaAdmin = prompt(`Por segurança, insira a senha da conta que você está logado (${usuarioAtual.email}):`);

    const userCredential = await createUserWithEmailAndPassword(auth, email, senha);
    const userId = userCredential.user.uid;

    let fotoURL = "https://github.com/enzocipriani.png";

    if (imagem) {
      const fileRef = storageRef(storage, `corretores/${userId}/profile.jpg`);
      const uploadTask = uploadBytesResumable(fileRef, imagem);

      await new Promise((resolve, reject) => {
        uploadTask.on(
          "state_changed",
          null,
          (error) => reject(error),
          async () => {
            fotoURL = await getDownloadURL(uploadTask.snapshot.ref);
            resolve();
          }
        );
      });
    }
    
    await set(dbRef(db, `corretores/${userId}`), {
      id: userId,
      creci,
      nome,
      sobrenome,
      telefone,
      email,
      senha,
      fotoURL,
    });

    console.log("Corretor cadastrado com sucesso!");

    await signOut(auth);
    await signInWithEmailAndPassword(auth, emailAdmin, senhaAdmin);
    console.log("Administrador voltou a estar logado!");

  } catch (error) {
    console.error("Erro ao cadastrar corretor:", error);
    throw error;
  }
};
export const removerCorretor = async (userId) => {
  try {
    // Referência para a imagem no Firebase Storage
    const fileRef = storageRef(storage, `corretores/${userId}/profile.jpg`);

    // Tenta excluir a imagem do Storage
    try {
      await deleteObject(fileRef);
    } catch (error) {
      console.warn(
        "Imagem não encontrada ou erro ao excluir do Storage:",
        error
      );
    }

    // Remove os dados do corretor no banco de dados
    await remove(dbRef(db, `corretores/${userId}`));

    console.log("Corretor removido com sucesso!");
  } catch (error) {
    console.error("Erro ao remover corretor:", error);
    throw error;
  }
};

export const obterCorretores = async () => {
  try {
    const snapshot = await get(ref(db, "corretores"));
    if (snapshot.exists()) {
      const data = snapshot.val();
      return Object.keys(data).map((key) => ({
        id: key,
        ...data[key],
      }));
    }
    return [];
  } catch (error) {
    console.error("Erro ao obter corretores:", error);
    throw error;
  }
};

export const editarCorretor = async (
  id,
  creci,
  nome,
  sobrenome,
  telefone,
  email,
  imagem
) => {
  try {
    let fotoURL = null;

    // Se houver uma nova imagem, faça o upload e atualize a URL
    if (imagem) {
      const fileRef = storageRef(storage, `corretores/${id}/profile.jpg`);
      const uploadTask = uploadBytesResumable(fileRef, imagem);

      await new Promise((resolve, reject) => {
        uploadTask.on(
          "state_changed",
          null,
          (error) => {
            console.error("Erro ao fazer upload da nova imagem:", error);
            reject(error);
          },
          async () => {
            fotoURL = await getDownloadURL(uploadTask.snapshot.ref);
            resolve();
          }
        );
      });
    }

    // Atualiza os dados no banco de dados
    await update(dbRef(db, `corretores/${id}`), {
      creci,
      nome,
      sobrenome,
      telefone,
      email,
      ...(fotoURL && { fotoURL }), // Atualiza a foto apenas se houver uma nova
    });

    console.log("Corretor atualizado com sucesso!");
  } catch (error) {
    console.error("Erro ao editar corretor:", error);
    throw error;
  }
};
